module.exports = __webpack_public_path__ + "assets/img/2.8ff22205.png";